<template>
  <span>
      <ButtonField text="导入" primary @click="visible = true"/>
      <Modal v-if="visible" v-model="visible"
             :visible="visible"
             :title="'导入文件'"
             :showFooter="false"
             :overlayOpacity="0.5"
             @update:visible="visible = $event"
      >
           <a-form :form="form" @submit="handleSubmit">
                <div style="color: #cdcdcd;margin-bottom: 1rem">
                    <span style="color:red;margin-right: 0.5rem">*</span><span>管道类型</span>
                </div>
                <div style="margin:0 1rem 1rem 2rem">
                    <RadioField name="type" :options="radioOptions"
                            v-model="type"/>
                </div>
                <!--   <input type="file" ref="upload" @change="onChange" style="display: none" />-->
                <!--   <a-button @click="upload">{{ file ? '重新上传' : '上传'}}</a-button>-->
              <div style="color: #cdcdcd;margin-bottom: 1rem">文件</div>
              <UploadField @files-uploaded="handleFilesUploaded" style="margin-bottom: 1rem;"/>

            <div class="right">
              <a-space>
                <ButtonField text="取消" @click="cancel" secondary />
                <ButtonField text="导入" primary @click="handleSubmit"/>
              </a-space>
            </div>
          </a-form>
        </Modal>
  </span>
</template>
<script>
import { importFile } from "@/api/assets";
import Modal from '@/components/water-affairs-style/modal.vue';

export default {
    components: {
        Modal
    },
  props: {
    category: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      visible: false,
      form: this.$form.createForm(this),
      file: null,
      saveLoading: false,
      radioOptions:[
          { name: '雨水', value: 'rain'},
          { name: '污水', value: 'sewage'}
        ]
      };
  },
  methods: {
    handleFilesUploaded(files) {
        console.log("上传的文件：", files);
        // 在这里处理上传的文件
    },
    upload() {
      this.$refs.upload.click();
    },
    onChange(e) {
      const files = e.target.files;
      if (files.length === 0) {
        return;
      }
      this.file = files[0];
      e.target.value = null;
    },

    handleSubmit(e) {
      e.preventDefault();

      this.form.validateFields(async (err, values) => {
        if (!err) {
          const data = new FormData();
          data.append("category", this.category);
          data.append("type", values.type);
          data.append("file", this.file);
          this.saveLoading = true;
          importFile(data)
            .then((res) => {
              console.log("res", res);
              this.$emit("refresh");
              this.cancel();
            })
            .finally(() => {
              this.saveLoading = false;
            });
        }
      });
    },
    cancel() {
      this.form.resetFields();
      this.file = null;
      this.visible = false;
    },
  },
};
</script>
<stye scoped>
::v-deep .ant-form-item-label > label{
  color:#fff;
}
</stye>